<template>
  <v-data-table
    v-if="appLayouts.length"
    :headers="headers"
    :items="appLayouts"
    :items-per-page="10"
    :search="search"
    :sort-by="['id']"
    sort-desc
  >
    <template v-slot:top>
      <v-text-field
        v-model="search"
        label="Search all the fields"
        outlined
        append-icon="mdi-magnify"
      ></v-text-field>
    </template>

    <template v-slot:item.primary_color="{ item }">
      <v-chip dark :color="`#${item.primary_color}`">{{
        item.primary_color
      }}</v-chip>
    </template>

    <template v-slot:item.secondary_color="{ item }">
      <v-chip dark :color="`#${item.secondary_color}`">{{
        item.secondary_color
      }}</v-chip>
    </template>

    <template v-slot:item.created_at="{ item }">
      {{ item.created_at | created_at }}
    </template>

    <template v-slot:item.action="{ item }">
      <div class="text-center">
        <v-menu transition="scale-transition" origin="center center">
          <template v-slot:activator="{ on }">
            <v-btn text icon x-small v-on="on">
              <v-icon>mdi-cog</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="$emit('edit', item)">
              <v-list-item-title>
                <v-icon class="mr-1" small>mdi-account-edit</v-icon>
                Edit
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="$emit('delete', item)">
              <v-list-item-title>
                <v-icon class="mr-1" small>mdi-delete</v-icon>
                Delete
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import moment from 'moment';

export default {
  name: 'AppLayouts',

  filters: {
    created_at(value) {
      if (!value) return 'no value';

      return moment(value).fromNow();
    }
  },

  data: () => ({
    search: '',

    filter: {
      name: '',
      description: ''
    }
  }),

  computed: {
    appLayouts() {
      return this.$store.getters['app_layout/RETRIEVED_APP_LAYOUTS'];
    },

    headers() {
      return [
        {
          text: 'ID',
          align: 'left',
          sortable: true,
          value: 'id'
        },
        { text: 'Name', value: 'name' },
        { text: 'Instance', value: 'instance' },
        { text: 'Primary color', value: 'primary_color' },
        { text: 'Secondary color', value: 'secondary_color' },
        { text: 'Emails', value: 'emails' },
        { text: 'Created at', value: 'created_at' },
        { text: 'Actions', value: 'action', align: 'center' }
      ];
    }
  },

  created() {
    this.$store.dispatch('app_layout/retrieveAppLayouts').then(({ data }) => {
      this.$store.commit('app_layout/retrievedAppLayouts', data);
    });
  }
};
</script>
